/**
 * Estilos visuales unificados por paquete.
 * Asignados por slug (no por índice) para mantener consistencia entre /paquetes
 * y la sección de paquetes del inicio aunque cambie el orden.
 */

export type PackageTierStyle = {
  /** border + ring de la card */
  cardBorder: string;
  /** color del icono (Package, Check de servicios nuevos en /paquetes) */
  iconClass: string;
  /** color del texto del nombre del paquete y badges discretos */
  badgeText: string;
  /** bg suave del chip "Nuevo" en /paquetes */
  accentBg: string;
  /** clases del botón "Elegir ..." */
  buttonClass: string;
  /** badge superior (ribbon) opcional: "Más elegido", "Más completo", etc. */
  ribbon?: { label: string; class: string };
};

export const PACKAGE_STYLES: Record<string, PackageTierStyle> = {
  "base-florida": {
    cardBorder: "border-teal-500/35 ring-1 ring-teal-500/10",
    iconClass: "text-teal-400",
    badgeText: "text-teal-300",
    accentBg: "bg-teal-500/10",
    buttonClass: "bg-teal-700 text-white hover:bg-teal-700/90",
  },
  "operacion-lista": {
    cardBorder: "border-primary/60 ring-1 ring-primary/30",
    iconClass: "text-primary",
    badgeText: "text-primary",
    accentBg: "bg-primary/10",
    buttonClass: "bg-primary text-primary-foreground hover:bg-primary/90",
    ribbon: { label: "Más elegido", class: "bg-primary text-primary-foreground" },
  },
  "lanzamiento-premium": {
    cardBorder: "border-violet-500/60 ring-1 ring-violet-500/25",
    iconClass: "text-violet-400",
    badgeText: "text-violet-300",
    accentBg: "bg-violet-500/10",
    buttonClass: "bg-violet-700 text-white hover:bg-violet-700/90",
    ribbon: { label: "Más completo", class: "bg-violet-700 text-white" },
  },
};

export const DEFAULT_PACKAGE_STYLE: PackageTierStyle = {
  cardBorder: "border-hairline",
  iconClass: "text-muted-foreground",
  badgeText: "text-muted-foreground",
  accentBg: "bg-muted/20",
  buttonClass: "bg-primary text-primary-foreground hover:bg-primary/90",
};

export function getPackageStyle(slug: string): PackageTierStyle {
  return PACKAGE_STYLES[slug] ?? DEFAULT_PACKAGE_STYLE;
}
